import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useAssessments({ memberId }) {
  const [assessments, setAssessments] = useState(null);

  const [shouldRefetch, setRefresh] = useState({});

  const refresh = () => {
    setRefresh({});
  };

  useEffect(() => {
    axios
      .get(routes.api.managers.assessments.index, {
        params: {
          member_id: memberId,
        },
      })
      .then((response) => {
        setAssessments(response.data.data);
      });
  }, [memberId, shouldRefetch]);

  return { assessments, refresh };
}
